<template>
  <a-drawer title="构建记录" :body-style="{ paddingBottom: '80px' }" :visible="visible" :width="900" @close="onClose">
    <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="record_id" :loading="loading" @change="handlePageChange">
      <span slot="result" slot-scope="text, record">
        <a-tag :color="pipelineBuildStatus[record.status].color"> {{ pipelineBuildStatus[record.status].label }} </a-tag>
      </span>
      <span slot="triggerMode" slot-scope="text, record"> {{ triggerModes[record.trigger_mode].label }}</span>
      <span slot="action" slot-scope="text, record">
        <a v-tc="{ name: '查看构建详情' }" :href="link(record.record_id)" target="_blank">查看详情</a>
      </span>
    </a-table>
  </a-drawer>
</template>
<script>
import { pipelineRecordList } from '@/api/project/pipeline';
import { pipelineBuildStatus } from '@/utils/dictionary';
export default {
  props: {
    pipelineId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      pipelineBuildStatus,
      triggerModes: {
        1: {
          label: '自动触发'
        },
        2: {
          label: '手动触发'
        }
      },
      visible: false,
      loading: false,
      filterForm: {
        page_size: 10,
        page_number: 1
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      tableData: [],
      columns: [
        {
          title: 'ID',
          width: 100,
          key: 'record_id',
          dataIndex: 'record_id'
        },
        {
          width: 100,
          key: 'result',
          title: '构建状态',
          dataIndex: 'result',
          scopedSlots: { customRender: 'result' }
        },
        {
          width: 100,
          title: '触发方式',
          key: 'trigger_mode',
          dataIndex: 'trigger_mode',
          scopedSlots: { customRender: 'triggerMode' }
        },
        {
          title: '分支',
          key: 'branch',
          dataIndex: 'branch'
        },
        {
          key: 'duration',
          title: '持续时间',
          dataIndex: 'duration'
        },
        {
          width: 180,
          title: '触发时间',
          key: 'created_time',
          dataIndex: 'created_time'
        },
        {
          width: 80,
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  computed: {
    link() {
      return recordId => {
        return this.$router.resolve({
          name: 'page:project:cicd:pipeline:detail',
          query: { recordId: recordId }
        }).href;
      };
    }
  },
  methods: {
    onClose() {
      this.visible = false;
    },

    onOpen(record) {
      this.visible = true;
      this.filterForm.pipeline_id = record.pipeline_id;
      this.getRecordList();
    },

    getRecordList() {
      this.loading = true;
      this.tableData = [];
      pipelineRecordList({ ...this.filterForm, project_id: this.projectId })
        .then(response => {
          this.loading = false;
          this.tableData = response.data.records;
          this.pagination.total = response.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handlePageChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getRecordList();
    }
  }
};
</script>
